import { LinearProgress, Stack, TextField, Typography } from "@mui/material";
import {
  addDoc,
  collection,
  doc,
  DocumentReference,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { ExternalKeyData, ExternalKeyCursor } from "functions/src/shared";
import {
  Collection_ExternalKeyCursor,
  Collection_ExternalKeyData,
} from "functions/src/shared/Digital/CollectionName";
import { RedeemKeyPlatform } from "functions/src/shared/Digital/ProductStoryData";
import * as React from "react";
import { firestore } from "../../Firebase/SDK/firestore";
import MajorButton from "../../Utility/MajorButton";
import SimpleSelect from "../../Utility/SimpleSelect";
import AdminCheck from "../AdminCheck";
import { useDocOnce } from "../../Firebase/useDoc";
import { useAlertContext } from "../../Alert/SnackBarProvider";

function useReadFile({ handler }: { handler: (result: string) => void }) {
  const [done, setDone] = React.useState(false);
  //   const [data,setData] =
  var inputRenderer = (
    <input
      type="file"
      //   accept="cvs"

      onChange={(evt) => {
        console.log("[Upload Captured] File changed");
        setDone(false);
        var tgt = evt.target;
        var files = tgt.files;

        var fileReaders: FileReader[] = [];
        if (FileReader && files && files.length) {
          for (var i = 0; i < files.length; i++) {
            fileReaders.push(new FileReader());

            console.log("[Upload Captured] read:" + i);
            fileReaders[i].onload = function (ev) {
              console.log("read Onload", i, ev.target.result as string);
              handler(ev.target.result as string);
              setDone(true);
            };
            fileReaders[i].readAsText(files[i], "utf-8");
          }
        }
      }}
    ></input>
  );
  return { inputRenderer, done };
}
async function ImportKeysAndCreateDocuments(
  keyText: string,
  keySource: RedeemKeyPlatform,
  productKeyID: string,
  updateComplete: (index: number) => void
) {
  var keys = keyText.split("\n");
  console.log("keys", keys);
  //先建立indexData

  var promises: Promise<any>[] = [];
  var keyName = `${productKeyID}_${keySource}`;

  // var { docRef: indexCursorRef, result: cursorData } =
  //   useDocOnce<ExternalKeyCursor>(Collection_ExternalKeyCursor, keyName);
  var indexCursorRef = doc(
    firestore,
    Collection_ExternalKeyCursor,
    keyName
  ) as DocumentReference<ExternalKeyCursor>;
  let cursorData = (await getDoc(indexCursorRef)).data() as ExternalKeyCursor;
  var offset = 0;

  //現在從哪開始
  if (cursorData != null) {
    offset = cursorData.count;
    console.log(indexCursorRef.firestore.toJSON());
    console.log("cursorData", cursorData.count, indexCursorRef.id);
  }
  var index = offset;

  //TODO: 可以先查第一筆看看? 抽樣?
  console.log("offset", offset, "index", index, "i");
  var keyID = `${keyName}_${index}`;
  console.log("collection:" + Collection_ExternalKeyData, "id:", keyID);
  var keyCollection = collection(firestore, Collection_ExternalKeyData);
  var keyQuery = query(keyCollection, where("keyStr", "==", keys[0].trim()));
  var existDocs = await getDocs(keyQuery);
  if (!existDocs.empty) {
    return false;
  }

  var batchCount = 0;
  var batch = writeBatch(firestore);

  for (var i = 0; i < keys.length; i++) {
    var keyID = `${keyName}_${offset + i}`;
    console.log("keyID", keyID);
    if (batchCount == 500) {
      promises.push(
        batch.commit().then(() => {
          updateComplete((i / keys.length) * 100);
        })
      );
      batch = writeBatch(firestore);
      batchCount = 0;
    }

    const newKeyData: ExternalKeyData = {
      keyStr: keys[i].trim(),
      created_at: Date.now(),
      keysource: keySource,
    };

    // console.log("collection:" + Collection_ExternalKeyData, "id:", keyID);
    var keyDocRef = doc(firestore, Collection_ExternalKeyData, keyID);

    //FIXME: 需要檢查有key在裡面嗎？？？
    batch.set(keyDocRef, newKeyData);
    batchCount++;
    console.log("set key", keyID);
  }
  if (batchCount > 0) {
    promises.push(
      batch.commit().then(() => {
        updateComplete(100);
      })
    );
  }
  if (cursorData == null) {
    var p = setDoc<ExternalKeyCursor>(indexCursorRef, {
      currentIndex: -1,
      count: offset + i,
    });
    promises.push(p);
    // console.log("Create Cursor: count:", offset + i);
  } else {
    var p = updateDoc<ExternalKeyCursor>(indexCursorRef, { count: offset + i });
    // console.log("Update Cursor count ", offset + i);
    promises.push(p);
  }
  await Promise.all(promises);
  return true;
}
export default function AdminImportExternalKeyPage() {
  //要先選個product, 從storyblok
  const [keyText, setKeyText] = React.useState("");
  var keys = keyText.split("\n");
  const [productKeyID, setProductKeyID] = React.useState("");
  const [keySource, setKeySource] = React.useState<RedeemKeyPlatform>("Steam"); //TODO: 用選的
  var externalPlatforms: RedeemKeyPlatform[] = [
    "Steam",
    "Xbox",
    "PS_SIEJA-Asia",
    "PS_SIEJA-Japan",
    "PS_SIEA-America",
    "PS_SIEE-Europe",
    "PS_SIEK-Korea",
    "Switch_America",
    "Switch_Europe",
    "Switch_Japan",
    "Switch_Australia",
    "Switch_Hong Kong",
    "Switch_Korea",
  ];
  const { inputRenderer, done } = useReadFile({
    handler: (result: string) => {
      setKeyText(result);
      console.log("read text result", result);

      // Promise.all(promises).then((results) => {
      //   //TODO: 完成
      // });
    },
  });

  return (
    <AdminCheck fallback={<div>權限不足</div>}>
      <Typography variant="h4">匯入兌換碼</Typography>
      <Stack>
        <TextField
          label={"ProductKey PID"}
          name="ProductKeyPID"
          value={productKeyID}
          onChange={(e) => {
            setProductKeyID(e.target.value);
          }}
        ></TextField>
        <SimpleSelect
          name="country"
          value={keySource}
          //
          options={externalPlatforms}
          texts={externalPlatforms}
          onChange={(e) => {
            console.log("select:", e.target.value);
            //TODO: preview, 要不然很危險<
            //先存著，等等再update

            setKeySource(e.target.value as RedeemKeyPlatform);
          }}
        ></SimpleSelect>
        {inputRenderer}
        <div> Preview:</div>
        <div> {keys[0]}</div>
        <div>{keys[1]}</div>
        <div>...</div>
        <Uploader
          keyText={keyText}
          keySource={keySource}
          productKeyID={productKeyID}
        ></Uploader>
      </Stack>
    </AdminCheck>
  );
}
//匯入後要刪除就很麻煩了....
function Uploader({
  keyText,
  keySource,
  productKeyID,
}: {
  keyText: string;
  keySource: RedeemKeyPlatform;
  productKeyID: string;
}) {
  const [progress, setProgress] = React.useState(0);
  const alert = useAlertContext();
  return (
    <div>
      <MajorButton
        disabled={keyText == ""}
        onClick={async () => {
          if (productKeyID == "") {
            alert.show("ProductKeyID is empty", "warning");
            return;
          }
          let result = await ImportKeysAndCreateDocuments(
            keyText,
            keySource,
            productKeyID,
            (v) => {
              setProgress(v);
            }
          );
          if (result) alert.show("Success", "success");
          else alert.show("first key already exists!", "warning");
          // setKeyText("");
        }}
      >
        建立
      </MajorButton>
      <LinearProgress variant="determinate" value={progress}></LinearProgress>
    </div>
  );
}
